import React from 'react';
import { Hero } from './components/sections/Hero';
import { Agitation } from './components/sections/Agitation';
import { TopReviews } from './components/sections/TopReviews';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { WhoFor } from './components/sections/WhoFor';
import { WhyDifferent } from './components/sections/WhyDifferent';
import { SixBooks } from './components/sections/SixBooks';
import { ContentPreview } from './components/sections/ContentPreview';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Mission } from './components/sections/Mission';
import { SocialFeed } from './components/sections/SocialFeed';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <Hero data-id="element-1" />
      <TopReviews data-id="element-2" />
      <Agitation data-id="element-3" />
      <BeforeAfter data-id="element-4" />
      <WhoFor data-id="element-5" />
      <WhyDifferent data-id="element-6" />
      <SixBooks data-id="element-7" />
      <ContentPreview data-id="element-8" />
      <Bonuses data-id="element-9" />
      <Offer data-id="element-10" />
      <Guarantee data-id="element-11" />
      <Mission data-id="element-12" />
      <SocialFeed data-id="element-13" />
      <FAQ data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}